
import { Button } from '05-ui-kit';
import { declination } from '@artmizu/utils';
import { computed } from '@nuxtjs/composition-api';
import { useAuthStore } from '~/store/modal/auth';
const __sfc_main = {};
__sfc_main.props = {
  quantity: {
    key: "quantity",
    required: false,
    type: Number,
    default: 0
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    enable
  } = useAuthStore();
  const beautyBonusCountText = computed(() => {
    return `${props.quantity} ${declination(props.quantity, ['бонус', 'бонуса', 'бонусов'])}`;
  });
  return {
    enable,
    beautyBonusCountText
  };
};
__sfc_main.components = Object.assign({
  Button
}, __sfc_main.components);
export default __sfc_main;
